import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import './globals.css'

// Auto-reload when a lazy-loaded chunk no longer exists on the server.
// Typical case: the user has the app open during a deploy, then navigates to a
// route whose chunk hash was renamed in the new build, producing a "Failed to
// fetch dynamically imported module" error. Reloading picks up the new index.html
// (cf. nginx no-cache headers) and the new chunk hashes.
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

// Create a new router instance
const router = createRouter({ routeTree })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
